var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-comment-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v("Yorum Metni")]),
        _vm._v(" "),
        _c("a-textarea", {
          attrs: {
            placeholder:
              "Yorum metni girin (dinamik değişkenler kullanabilirsiniz: {{task.title}})",
            rows: 4,
          },
          on: { change: _vm.emitChange },
          model: {
            value: _vm.localConfig.comment,
            callback: function ($$v) {
              _vm.$set(_vm.localConfig, "comment", $$v)
            },
            expression: "localConfig.comment",
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v("\n            Dinamik değişkenler: "),
      _c("span", { pre: true }, [_vm._v("{{task.title}}")]),
      _vm._v(", "),
      _c("span", { pre: true }, [_vm._v("{{task.owner.name}}")]),
      _vm._v(", vb.\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }